var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/right_placeholder.9d125d51.jpg","uri@2x": __webpack_public_path__ + "static/media/right_placeholder.4de7cabd.jpg","uri@3x": __webpack_public_path__ + "static/media/right_placeholder.02c62606.jpg",
    width: 1034,
    height: 1024
});